import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { Col, Row } from '@design-system/components/grid/grid';
import { ReactComponent as Star } from './super-tooltip.svg';

export const SuperTooltipModal = ({
  isOpen,
  onClose,
}: {
  isOpen: boolean;
  onClose: () => void;
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="The superstar mode on!"
      modalClassName="w-full md:max-w-[700px]"
      columnCta
      primaryCta={{
        caption: 'Nice, let’s go!',
        onClick: onClose,
      }}
    >
      <Row justifyCenter alignCenter>
        <Col>
          <Star />
        </Col>
        <Col gap="xl" center>
          <Typography variant="body" fontWeight="medium">
            This button means you can get one step closer to becoming a
            superstar creator.
          </Typography>
          <Typography variant="body" fontWeight="medium">
            Click on supertooltip to get tips and tricks directly from our most
            successful creators.
          </Typography>
        </Col>
      </Row>
    </Modal>
  );
};
